import { mountSignIn } from './signin.ts';

/** /signin/: wallet sign-in for any PageID customer (the account names the customer). */
mountSignIn(document.getElementById('signin')!);
